import { render, staticRenderFns } from "./AnswerCommentChanges.vue?vue&type=template&id=7f17712f&"
import script from "./AnswerCommentChanges.vue?vue&type=script&lang=js&"
export * from "./AnswerCommentChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports